import React from "react"
import { Col, Row as ARow, Icon as AIcon } from "antd"
import { MoreIcon, CheckedIcon } from "../core/icons"
import Card from "../core/Card"

import styled from "styled-components"
const HeaderRow = styled(ARow)`
  margin: 0 -20px 10px;
  padding: 20px;
  border: none;
  background-color: #dcf5f1;
  text-transform: uppercase;
`

const CenteredCol = styled(Col)`
  display: flex;
  justify-content: center;
`

const Row = styled(ARow)`
  padding: 15px;
  border-bottom: solid 1px #e0e0e0;
`
const Features = props => (
  <Card>
    <HeaderRow style={{ marginTop: -20 }}>
      <Col sm={12}>Features</Col>
      <CenteredCol sm={6}>Free Plan</CenteredCol>
      <CenteredCol sm={6}>
        {props.isTeams ? "Teams Plan" : "Premium Plan"}
      </CenteredCol>
    </HeaderRow>
    {props.isTeams && (
      <div>
        <Row>
          <Col sm={12}>Teams Dashboard</Col>
          <CenteredCol sm={6}>
            <AIcon type="close" />
          </CenteredCol>
          <CenteredCol sm={6}>
            <CheckedIcon />
          </CenteredCol>
        </Row>
        <Row>
          <Col sm={1} />
          <Col sm={11}>Consolidated Biling</Col>
          <CenteredCol sm={6}>
            <AIcon type="close" />
          </CenteredCol>
          <CenteredCol sm={6}>
            <CheckedIcon />
          </CenteredCol>
        </Row>
        <Row>
          <Col sm={1} />
          <Col sm={11}>Unlimted sub-teams</Col>
          <CenteredCol sm={6}>
            <AIcon type="close" />
          </CenteredCol>
          <CenteredCol sm={6}>
            <CheckedIcon />
          </CenteredCol>
        </Row>
        <Row>
          <Col sm={1} />
          <Col sm={11}>Roles and Access Control</Col>
          <CenteredCol sm={6}>
            <AIcon type="close" />
          </CenteredCol>
          <CenteredCol sm={6}>
            <CheckedIcon />
          </CenteredCol>
        </Row>
        <Row>
          <Col sm={1} />
          <Col sm={11}>Advanced Team Reporting</Col>
          <CenteredCol sm={6}>
            <AIcon type="close" />
          </CenteredCol>
          <CenteredCol sm={6}>
            <CheckedIcon />
          </CenteredCol>
        </Row>
      </div>
    )}

    <Row>
      <Col sm={12}>Automatic Trip Detection</Col>
      {props.isAndroid ? (
        <CenteredCol sm={6} style={{ color: "#31B59F", fontWeight: "bolder" }}>
          Unlimited
        </CenteredCol>
      ) : (
        <CenteredCol sm={6}>30 trips per month</CenteredCol>
      )}
      <CenteredCol sm={6} style={{ color: "#31B59F", fontWeight: "bolder" }}>
        Unlimited
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Connect Bank / Credit Card</Col>
      <CenteredCol sm={6}>
        <AIcon type="close" />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Advanced PDF & Excel reports</Col>
      <CenteredCol sm={6}>
        <AIcon type="close" />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Work Hours</Col>
      <CenteredCol sm={6}>
        <AIcon type="close" />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Premium Support</Col>
      <CenteredCol sm={6}>
        <AIcon type="close" />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Basic Excel Reports</Col>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>IRS Compliant</Col>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Manual Trip Detection</Col>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Manual Expense Tracking</Col>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
    <Row>
      <Col sm={12}>Upload Unlimited Receipts</Col>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
      <CenteredCol sm={6}>
        <CheckedIcon />
      </CenteredCol>
    </Row>
  </Card>
)

export default Features



// WEBPACK FOOTER //
// ./src/subscriptions/Features.jsx